import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/public/public.routes').then((r) => r.routes),
  },
  {
    path: 'painel',
    loadChildren: () => import('./views/private/private.routes').then((r) => r.routes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
